import React, { useContext } from "react";
import { apiPut } from "../../utils/apiFetch";
import apiPath from "utils/apiPath";
import useToastContext from "hooks/useToastContext";
import { useTranslation } from "react-i18next";
import AuthContext from "context/AuthContext";
import { isEmpty } from "lodash";
import helpers from "../../utils/helpers";
import OTableHead from "components/reusable/OTableHead";
import { motion } from 'framer-motion';
import { FaRegEdit, FaUserEdit, FaUserSlash } from "react-icons/fa";
import { TbUserPlus } from "react-icons/tb";
import { Link, NavLink } from "react-router-dom";
const DriverTable = ({ country, allSubAdmin, page, sort, setSort, manager, setCategoryAdd }) => {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const notification = useToastContext();

  const handelStatusChange = async (item) => {
    try {
      const payload = {
        status: item?.status === "inactive" ? "active" : "inactive",
      };
      const path = `${apiPath.getVehicleList}/status-change/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.data?.success) {
        notification.success(result.data.message);
        allSubAdmin("listing");
        return
      }
      notification.error(result.data.message);
    } catch (error) {
      console.error("error in change status==>>>>", error.message);
    }
  };

  const handelRemoveDriver = async (item) => {
    try {
      const payload = {
        isDriverRemoved: true
      };
      const path = `${apiPath.editVehicle}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.data?.success) {
        notification.success(result.data.message);
        allSubAdmin("listing");
        return
      }
      notification.error(result.data.message);
    } catch (error) {
      console.error("error in remove==>>>>", error.message);
    }
  }

  const rowVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.1,
      },
    }),
  };

  return (
    <div className="p-3">
      <div className="overflow-x-auto rounded-lg border relative">
        <table className="dark:text-gray-400 w-full text-xs text-left text-[#A5A5A5]">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-3 text-center">
                {t("S.NO")}
              </th>
              <OTableHead sort={sort} name={"VEHICLE_NUMBER"} fieldName={"vehicleNumber"} setSort={setSort} />
              <OTableHead sort={sort} name={"DOT_NUMBER"} fieldName={"dotNumber"} setSort={setSort} />
              <OTableHead sort={sort} name={"CA_NUMBER"} setSort={setSort} fieldName={"caNumber"} />
              <OTableHead sort={sort} name={"ASSIGN_TO"} setSort={setSort} />
              <OTableHead sort={sort} name={"O_CREATED_AT"} fieldName={"createdAt"} setSort={setSort} />
              <OTableHead sort={sort} name={"O_STATUS"} setSort={setSort} fieldName={"status"} />
              <th scope="col" className="py-3 px-3 text-center">
                {t("O_ACTION")}
              </th>
            </tr>
          </thead>
          <tbody>
            {country?.map((staff, i) => {
              return (<motion.tr
                key={staff._id}
                custom={i}
                initial="hidden"
                animate="visible"
                variants={rowVariants}
                className={`bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 transition ${helpers.ternaryCondition(staff?.isDeleted, 'text-red-500 bg-[#f2f2f2]')}`}
              >
                <th scope="row" className="py-2 px-3 border-r text-center font-medium text-gray-900  dark:text-white">
                  {i + 1 + 10 * (page - 1)}
                </th>
                <td className="py-2 px-3 whitespace-nowrap border-r">
                  {staff?.vehicleNumber}
                </td>

                <td className="py-2 px-3 whitespace-nowrap border-r">
                  {staff?.dotNumber}
                </td>

                <td className="py-2 px-3 whitespace-nowrap border-r">
                  {staff?.caNumber}
                </td>
                <td className="py-2 px-3 whitespace-nowrap border-r">
                  {helpers.ternaryCondition(!isEmpty(staff?.driverDetails), <NavLink to='/driver-manager/view' state={{ ...staff?.driverDetails, from: 'vehicle' }} className={'underline text-blue-500'}>{helpers.capitalizeFirstWord(staff?.driverDetails?.fullName || 'N/A')}</NavLink>, helpers.capitalizeFirstWord(staff?.driverDetails?.fullName || 'N/A'))}
                  { }
                </td>

                <td className="py-2 px-3 whitespace-nowrap gap-2 border-r">
                  {helpers.getDateAndTime(staff?.createdAt)}
                </td>

                <td className="py-2 px-3 whitespace-nowrap border-r">
                  {staff?.isDeleted === true ? (
                    <span className="text-red-500 font-semibold">Deleted</span>
                  ) : (
                    <label
                      className={`items-center cursor-pointer inline-flex relative ${helpers.ternaryCondition(!isEmpty(manager), !manager?.add, !user?.permission?.length == 0) ? "opacity-50 cursor-not-allowed" : ""}`}
                      title={`${staff?.status === "active" ? "Active" : "Inactive"}`}
                    >
                      <input
                        className="sr-only peer"
                        disabled={helpers.ternaryCondition(!isEmpty(manager), !manager?.add, !user?.permission?.length == 0)}
                        checked={staff?.status === "active"}
                        onChange={(e) => helpers.alertFunction(`Are you sure you want to ${e.target.checked ? "active" : "inactive"} "${staff?.vehicleNumber}"?`, staff, handelStatusChange)}
                        type="checkbox"
                      />
                      <div
                        className={`peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 w-10 h-5 bg-gray-200 rounded-full dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-gradientTo ${helpers.ternaryCondition(!isEmpty(manager), !manager?.add, !user?.permission?.length == 0) ? "bg-gray-300 dark:bg-gray-600" : ""
                          }`}
                      />
                    </label>
                  )}
                </td>
                <td className="py-1 px-3 whitespace-nowrap  gap-2 border-r">
                  <ul className="flex justify-center items-center">
                    <li
                      onClick={() => {
                        setCategoryAdd({ ...staff, type: 'edit' })
                      }}
                      className="px-2 py-2 hover:text-LightBlue dark:hover:bg-transparent"
                      title={'Edit'}
                    >
                      <FaRegEdit className="cursor-pointer text-black dark:text-gray-500" size={18} />
                    </li>

                    {helpers.ternaryCondition(staff?.status == 'active',
                      <>
                        <li
                          onClick={() => {
                            setCategoryAdd({ ...staff, type: helpers.ternaryCondition(!isEmpty(staff?.driverDetails), 'update', 'assign') })
                          }}
                          className="px-2 py-2 hover:text-LightBlue dark:hover:bg-transparent"
                          title={helpers.ternaryCondition(!isEmpty(staff?.driverDetails), 'Update Driver', 'Assign Driver')}
                        >
                          {helpers.ternaryCondition(!isEmpty(staff?.driverDetails), <FaUserEdit className="cursor-pointer w-5 h-5 text-black dark:text-gray-500" />, <TbUserPlus className="cursor-pointer w-5 h-5 text-black dark:text-gray-500" />)}
                        </li>


                        {helpers.andOperator(staff?.driverDetails, <li
                          onClick={() => {
                            helpers.alertFunction(`Are you sure you want to remove "${staff?.driverDetails?.fullName || ''}" driver from this vehicle?`, staff, handelRemoveDriver)
                          }}
                          className="px-2 py-2 hover:text-LightBlue dark:hover:bg-transparent"
                          title={'Remove Driver'}
                        >
                          <FaUserSlash className="cursor-pointer w-5 h-5 text-red-500" />
                        </li>)}

                      </>, '')}
                  </ul>
                </td>
              </motion.tr>)
            })}
            {isEmpty(country) ? (
              <tr className="bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700">
                <td className="py-4 px-6" colSpan={12}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DriverTable;
